export default __webpack_public_path__ + "static/media/headerImage.1ca24963.png";